var hamburgerMenu = document.getElementById("hamburger-menu");
var nav = document.getElementsByTagName("nav");

hamburgerMenu.addEventListener("click", (event) => {
    // if (nav.style.display == "none") {
    //     nav.style.display = "block";
    // }
    for (var i = 0; i < nav.length; i++) {
        hamburgerMenu.classList.toggle("change");
        
        if (nav[i].style.display != "block") {
            nav[i].style.display = "block";
            break;
        }
        else {
            nav[i].style.display = "none";
            break; 
        }
    }

});